<template>
  <div class="list foreign-manage-data-page">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>外管数据</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="90" :show-message="false" label-position="right">
        <Row :gutter="24">
          <Col :span="6">
            <Form-item label="时间范围">
              <Date-picker
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="dateRange"
                placeholder="请选择时间范围"
                @on-change="onDateRangeChange">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="外管">
              <Select v-model="queryParam.studyAdviserId" placeholder="全部" clearable filterable>
                <Option v-for="item in studyAdviserList" :value="item.id" :key="item.id">{{ item.nickname }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="外教来源">
              <Select v-model="queryParam.channel" placeholder="全部" clearable>
                <Option :value="1">欧美</Option>
                <Option :value="2">菲教</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item>
              <Button type="primary" :loading="searchLoading" @click="search">查询</Button>
              <Button type="primary" :loading="exportLoading" @click="exportData" style="margin-left: 10px">导出</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>

    <div class="table-container" style="overflow-x: hidden;">
      <Table :columns="columns" :data="tableData" :loading="tableLoading" border stripe></Table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TchForeignManageData',
  data () {
    return {
      searchLoading: false,
      exportLoading: false,
      tableLoading: false,
      studyAdviserList: [],
      dateRange: [],
      queryParam: {
        startDate: '',
        endDate: '',
        studyAdviserId: '',
        channel: ''
      },
      columns: [
        {
          title: ' ',
          key: 'teacherType',
          align: 'center',
          width: 100,
          fixed: 'left',
          renderHeader: (h) => h('span', '')
        },
        {title: '老师数', key: 'teacherCount', align: 'center', width: 100},
        {title: '买断课时数', key: 'buyOutLessonCount', align: 'center', width: 120},
        {title: '上课数', key: 'lessonCount', align: 'center', width: 100},
        {title: '上课率', key: 'attendanceRate', align: 'center', width: 100},
        {title: '第四周上课率', key: 'fourthWeekAttendanceRate', align: 'center', width: 130},
        {title: '请假数', key: 'leaveCount', align: 'center', width: 100},
        {title: '外教请假率', key: 'foreignTeacherLeaveRate', align: 'center', width: 120},
        {title: '临时正常上课数', key: 'temporaryNormalLessonCount', align: 'center', width: 140},
        {title: '临时请假数', key: 'temporaryLeaveCount', align: 'center', width: 120},
        {title: '临时请假率', key: 'temporaryLeaveRate', align: 'center', width: 120},
        {title: '返课时', key: 'returnLessonHours', align: 'center', width: 100},
        {title: 'CPE+回访', key: 'cpeAndFollowUp', align: 'center', width: 100},
        {title: '外教离职', key: 'foreignTeacherResigned', align: 'center', width: 100},
        {title: '外教淘汰数', key: 'foreignTeacherEliminated', align: 'center', width: 100},
        {title: '外教流失数', key: 'foreignTeacherLost', align: 'center', width: 100},
        {title: '培训中外教数', key: 'trainingForeignTeachers', align: 'center', width: 140}
      ],
      tableData: this.createDefaultTableRows()
    }
  },
  mounted () {
    this.getStudyAdviserList()
    this.initDefaultDate()
    this.search()
  },
  methods: {
    getStudyAdviserList () {
      this.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then((res) => {
        this.studyAdviserList = res && res.data ? res.data : []
      })
    },
    initDefaultDate () {
      const now = this.$moment()
      const day = now.day()
      let friday = now.clone()
      if (day === 0) {
        friday = now.clone().subtract(2, 'days')
      } else if (day >= 6) {
        friday = now.clone().subtract(1, 'days')
      } else {
        friday = now.clone().add(5 - day, 'days')
      }
      const saturday = friday.clone().subtract(6, 'days')
      this.dateRange = [saturday.format('YYYY-MM-DD'), friday.format('YYYY-MM-DD')]
      this.queryParam.startDate = this.dateRange[0]
      this.queryParam.endDate = this.dateRange[1]
    },
    onDateRangeChange (value) {
      if (value && value.length === 2) {
        this.queryParam.startDate = value[0]
        this.queryParam.endDate = value[1]
      } else {
        this.queryParam.startDate = ''
        this.queryParam.endDate = ''
      }
    },
    search () {
      this.searchLoading = true
      this.tableLoading = true
      this.$http.post('/tch/statistics', {...this.queryParam}).then((res) => {
        this.tableData = this.normalizeTableData(res && res.data ? res.data : [])
      }).catch(() => {
        this.tableData = this.normalizeTableData([])
      }).finally(() => {
        this.searchLoading = false
        this.tableLoading = false
      })
    },
    exportData () {
      this.exportLoading = true
      this.$http.post('/tch/statistics/export', {...this.queryParam}, {responseType: 'blob'}).then((response) => {
        const blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '外管数据.xlsx'
        link.click()
      }).finally(() => {
        this.exportLoading = false
      })
    },
    createDefaultTableRows () {
      return ['正式老师', '试用期老师', '汇总'].map(type => {
        return {
          teacherType: type,
          teacherCount: 0,
          buyOutLessonCount: 0,
          lessonCount: 0,
          attendanceRate: 0,
          fourthWeekAttendanceRate: 0,
          leaveCount: 0,
          foreignTeacherLeaveRate: 0,
          temporaryNormalLessonCount: 0,
          temporaryLeaveCount: 0,
          temporaryLeaveRate: 0,
          returnLessonHours: 0,
          cpeAndFollowUp: 0,
          foreignTeacherResigned: 0,
          foreignTeacherEliminated: 0,
          foreignTeacherLost: 0,
          trainingForeignTeachers: 0
        }
      })
    },
    normalizeTableData (data) {
      const defaultRows = this.createDefaultTableRows()
      if (!data || data.length === 0) {
        return defaultRows
      }
      const dataMap = {}
      data.forEach(item => {
        if (item && item.teacherType) {
          dataMap[item.teacherType] = item
        }
      })
      return defaultRows.map(row => Object.assign({}, row, dataMap[row.teacherType] || {}))
    }
  }
}
</script>

<style scoped>
.list.foreign-manage-data-page { padding: 20px; overflow-x: hidden; }
.breadcrumb { margin-bottom: 20px; }
.search { background: #f8f8f9; padding: 20px; margin-bottom: 20px; border-radius: 4px; }
.table-container { background: #fff; padding: 20px; border-radius: 4px; overflow-x: hidden; }
</style>



// WEBPACK FOOTER //
// TchForeignManageData.vue?4250ee96